import React from 'react';
import {
    matchPath,
    Redirect,
    Route,
    Switch,
    useLocation,
} from 'react-router-dom';

import LandingPagePbx from 'flow/components/nav/landing-pages/LandingPagePbx';
import Conference from 'flow/route-components/ConferenceMain';
import PbxConnection from 'flow/route-components/PbxConnectionSettings';
import PbxIvr from 'flow/route-components/PbxIvr';
import PbxIvrCalendar from 'flow/route-components/PbxIvrCalendar';
import PbxProfiles from 'flow/route-components/PbxProfiles';
import useAppContext from 'flow/hooks/useAppContext';
import { routes } from 'flow/types/routes';
import {
    getSlimmedTeamsLandingRoute,
    isSlimmedTeamsApp,
} from 'flow/utils/app-utils';

import PbxLiveChat from './pbx/PbxLiveChat';
import PbxOverview from './pbx/PbxOverview';
import PbxQueueRoutes from './pbx/PbxQueueRoutes';
import PbxVoicemail from './pbx/PbxVoicemail';
import AiCoworker from 'flow/pages/AiCoworker';
import Settings from 'flow/pages/ai-coworker/Settings';
import General from 'flow/pages/ai-coworker/General';
import QueueAndChatLoginPerProfile from 'flow/components/Setting/SettingsQueueLoginProfile';
import QueueAndChatLogin from 'flow/components/Setting/QueueAndChatLogin';
import AiCoworkerCallRecordDetailPageV2 from 'flow/pages/ai-coworker/AiCoworkerCallRecordDetailPageV2';

const PbxSwitch = () => (
    <Switch>
        <Route
            path={
                routes[
                    'pbx.aicoworker.extensionKey.settings.queuing-system-login.queueKey'
                ]
            }
            component={QueueAndChatLoginPerProfile}
        />
        <Route
            path={
                routes[
                    'pbx.aicoworker.extensionKey.settings.queuing-system-login'
                ]
            }
            component={QueueAndChatLogin}
        />
        <Route
            path={routes['pbx.aicoworker.extensionKey.settings.general']}
            component={General}
        />
        <Route
            path={routes['pbx.aicoworker.extensionKey.settings']}
            component={Settings}
        />
        <Route
            path={routes['pbx.channels.entityKey']}
            component={PbxLiveChat}
        />
        <Route
            path={routes['pbx.conference.meetingCode']}
            component={Conference}
        />
        <Route path={routes['pbx.conference']} component={Conference} />
        {/* The personal meeting room moved to the meetings page under
            /messages. Kept for old links and bookmarks. */}
        <Redirect
            from={routes['pbx.conferences.entityKey']}
            to={routes['messages.meetings']}
        />
        <Route
            path={routes['pbx.connections.connectionKey']}
            component={PbxConnection}
        />
        <Route
            path={routes['pbx.queues.entityKey']}
            component={PbxQueueRoutes}
        />
        <Route
            path={routes['pbx.refers.entityKey.profiles.calendar']}
            component={PbxIvrCalendar}
        />
        <Route
            path={routes['pbx.refers.entityKey.profiles']}
            component={PbxProfiles}
        />
        <Route path={routes['pbx.refers.entityKey']} component={PbxIvr} />
        <Route
            path={routes['pbx.voicemails.entityKey']}
            component={PbxVoicemail}
        />
        <Route
            path={routes['pbx.aicoworker.extensionKey.calls.callRecordKey']}
            component={AiCoworkerCallRecordDetailPageV2}
        />
        <Route
            path={routes['pbx.aicoworker.extensionKey']}
            component={AiCoworker}
        />
        <Route path={routes['pbx.overview']} component={PbxOverview} />
        <Route path="/" component={LandingPagePbx} />
    </Switch>
);

const PbxRoutes = () => {
    const { embedded } = useAppContext();
    const { pathname } = useLocation();

    // The Teams manifest opens the tab on /pbx, which the slimmed-down Teams
    // app hides (AC-1678), so it lands on Contacts like StartView does. Only
    // that entry point moves: meeting links under /pbx/conference keep working.
    if (
        isSlimmedTeamsApp(embedded) &&
        matchPath(pathname, { path: routes['pbx'], exact: true })
    ) {
        return <Redirect to={getSlimmedTeamsLandingRoute()} />;
    }

    return <PbxSwitch />;
};

export default PbxRoutes;
